export default __webpack_public_path__ + "static/media/cpv_43_machines-mines-quarry-building.3fe74a3e.svg";